import api from '~/api/Endpoints';
import type { Suggestions } from '~/types';
export type GetSuggesionsCategoriesResponse = {
  categories: Suggestions.Category[];
  industries: Suggestions.Industry[];
};
export const getSuggestionsCategories = async () => {
  return api.get(`/suggestions/categories`, {
    headers: {
      'cache-control': 'no-cache',
    },
  });
};

export const getSuggestions = async (search: string) => {
  return api.get(`/suggestions`, {
    query: {
      search,
    },
  });
};
